import { logger } from './loggerInstance';
import { BETTERSTACK_API_KEY } from '@constants';

// The token only feeds the deprecated BetterStack transport; the Datadog
// transport is initialized in initDatadog. Delete this once BetterStack is removed.
export const initLogger = (): void => {
  logger.init?.(BETTERSTACK_API_KEY);
};
